export default function Contact() {
  return (
    <section id="contact" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-2">联系我们</h2>
          <p className="text-sm text-foreground-500">有漫画推荐、意见反馈或合作意向？欢迎联系我们</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
          <div className="p-6 rounded-xl bg-background-100 text-center">
            <div className="w-11 h-11 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center">
              <i className="ri-mail-line text-xl text-primary-500"></i>
            </div>
            <h3 className="text-sm font-bold text-foreground-900 mb-1">投稿推荐</h3>
            <p className="text-xs text-foreground-500 mb-2">推荐你喜欢的漫画作品</p>
            <span className="text-xs text-primary-500 font-medium">tougao@kukanmanhua.com</span>
          </div>

          <div className="p-6 rounded-xl bg-background-100 text-center">
            <div className="w-11 h-11 mx-auto mb-3 rounded-xl bg-accent-100 flex items-center justify-center">
              <i className="ri-message-2-line text-xl text-accent-500"></i>
            </div>
            <h3 className="text-sm font-bold text-foreground-900 mb-1">意见反馈</h3>
            <p className="text-xs text-foreground-500 mb-2">帮助我们变得更好</p>
            <span className="text-xs text-primary-500 font-medium">fankui@kukanmanhua.com</span>
          </div>

          <div className="p-6 rounded-xl bg-background-100 text-center">
            <div className="w-11 h-11 mx-auto mb-3 rounded-xl bg-secondary-100 flex items-center justify-center">
              <i className="ri-service-line text-xl text-secondary-500"></i>
            </div>
            <h3 className="text-sm font-bold text-foreground-900 mb-1">商务合作</h3>
            <p className="text-xs text-foreground-500 mb-2">商业合作与推广事宜</p>
            <span className="text-xs text-primary-500 font-medium">hezuo@kukanmanhua.com</span>
          </div>
        </div>
      </div>
    </section>
  );
}